export default "__VITE_PUBLIC_ASSET__096722b9__"